<template>
  <div>
    <b-container fluid class="d-flex align-items-center back-wrapper">
          <b-row >
            <b-col lg="7" md="10">
              <router-link :to="{name: 'modelos'}" class="back-item">
                  <img class="arrow-back" src="img/theme/icn_arrowback.svg" alt="">
                  <span>Modelos</span>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header" >
              <b-col cols="8">
                <h3 class="mb-0">Editar fuente</h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <base-alert v-if="success === true" type="success" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Bien hecho!</strong> La información de la fuente se actualizó exitosamente.
              </base-alert>
              <base-alert v-if="success === false" type="danger" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Error!</strong> {{error}}
              </base-alert>
              <h6 class="heading-small text-muted mb-4">Información del fuente</h6>


              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Nombre de la fuente"
                      placeholder="Nombre"
                      v-model="nameFont"
                      name="Nombre"
                      required
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>
              <hr class="my-4">
              <b-button type="submit" variant="primary" class="mt-4">Guardar</b-button>
              <b-button :to="{ name: 'modelos'}" variant="danger" class="mt-4">Cancelar</b-button>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import qs from 'qs'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      nameFont: '',
      success: '',
      error: '',
      brand: '',
      gender: '',
      optionsModels: []
    }
  },
  methods: {
    updateProfile() {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({
          api_token: this.token,
          user_id: this.user,
          option: 'edit_font',
          f_id: this.$route.params.fontsId,
          f_name: this.nameFont
        }),
      )
      .then((response) => {
        if (!response.data.error.code) {
          this.success = true
        } else {
          this.success = false
          this.error = response.data.error.description
        }
      })
      .catch((err) => {
        console.log(err)
      })
    }
  },
  created() {
    this.token = localStorage.getItem('token')
    this.user = localStorage.getItem('id_user')
    axios
    .post(
      process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
      qs.stringify({
        api_token: this.token,
        user_id: this.user,
        option: 'get_font',
        f_id: this.$route.params.fontsId
      }),
    )
    .then((response) => {
      if (!response.data.error.code) {
        this.nameFont = response.data.font.name
        }
    })
    .catch((err) => {
      console.log(err)
    })
  }
};
</script>
<style></style>
